import api from "./api";

export async function listEmailTemplates() {
  return api.get(`/api/emailqueue/templates/`);
}

export async function saveEmailTemplate(kind, { subject, body }) {
  return api.put(`/api/emailqueue/templates/${kind}/`, { subject, body });
}

// Goes back to the built-in wording.
export async function resetEmailTemplate(kind) {
  return api.delete(`/api/emailqueue/templates/${kind}/`);
}

// The subject and body filled in with made-up values:
// { subject, body, unknown_placeholders }.
export async function previewEmailTemplate(kind, { subject, body }) {
  return api.post(`/api/emailqueue/templates/${kind}/preview/`, {
    subject,
    body,
  });
}
